import { fontWeightEnum, Text, textVariantsEnum } from '@/components/Text';
import React from 'react';
import styles from './LeaveRequest.module.scss';
import { Button, buttonVariants } from '@/components/Button';
export const LeaveRequestModal = ({
  onAccept,
  onDecline,
  selectedData,
  ReporterTemplete,
  ReportDateTempelate,
  TaskDateTempelate,
  onClose,
  approveLoading,
  rejectLoading,
}) => {
  if (!selectedData) return null;
  return (
    <div className={styles.leaveRequestModal}>
      <Text
        variant={textVariantsEnum.Text_13}
        fontWeight={fontWeightEnum.Medium}
      >
        Process Leave Request
      </Text>
      <div className={styles.leaveRequestModalContent}>
        <Text
          variant={textVariantsEnum.Text_13}
          fontWeight={fontWeightEnum.Medium}
        >
          Type: {selectedData?.type}
        </Text>
        <Text
          variant={textVariantsEnum.Text_13}
          fontWeight={fontWeightEnum.Medium}
        >
          Leave Date: {TaskDateTempelate(selectedData)}
        </Text>
        <Text
          variant={textVariantsEnum.Text_13}
          fontWeight={fontWeightEnum.Medium}
        >
          Comment: {selectedData?.comment}
        </Text>
        <Text
          variant={textVariantsEnum.Text_13}
          fontWeight={fontWeightEnum.Medium}
        >
          Reporter: {ReporterTemplete(selectedData)}
        </Text>
      </div>
      <div className={styles.leaveRequestModalButtons}>
        <Button
          variant={buttonVariants.primary}
          onClick={onAccept}
          text="Accept"
          loading={approveLoading}
          disabled={approveLoading || rejectLoading}
        />
        <Button
          variant={buttonVariants.red}
          onClick={onDecline}
          text="Decline"
          loading={rejectLoading}
          disabled={approveLoading || rejectLoading}
        />
      </div>
    </div>
  );
};
